import staticPageModule from '../scripts/staticPage/staticPage.module.js';

import appDependency from '../scripts/appDependency.js';

appDependency.addItem(staticPageModule);
